import * as React from 'react';
import { DynamicLayout } from '@/layouts/v2/dynamic-layout';

import { AuthGuard } from '@/components/auth/guards/auth-guard';
import { SetupGuard } from '@/components/auth/guards/setup-guard';
import { CommunityAccessGuard } from '@/components/auth/guards/community-access-guard';
import { ChangePasswordGuard } from '@/components/auth/guards/change-password-guard';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps): React.JSX.Element {
  return (
    <AuthGuard>
      <SetupGuard>
        <CommunityAccessGuard>
          <ChangePasswordGuard>
            <DynamicLayout>{children}</DynamicLayout>
          </ChangePasswordGuard>
        </CommunityAccessGuard>
      </SetupGuard>
    </AuthGuard>
  );
}
